import Library from '@basic-orange/library';
export class Component {
    constructor(_elm, _componentId) {
        this.elm = _elm;
        this.componentId = _componentId;
        this.data = new Library.Data(this.elm).data;
    }
}
//# sourceMappingURL=component.js.map